<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("profile.mfaTitle") }}</h5>
    <div class="card">
      <div class="card-content">
        <h6 class="title is-6">現在多要素認証を未設定です</h6>
        <p>
          多要素認証とは、お客様のアカウントをハッカーなどから保護する仕組みです。<br />
          スマートフォンで稼働する認証アプリが必要となります。<br />
          以下のリンクから、お使いのスマートフォンに認証アプリを導入して次へ進んでください。
        </p>
        <h5 class="title is-5 mt-4">Google Authenticator</h5>
        <a
          href="https://apps.apple.com/us/app/google-authenticator/id388497605?itsct=apps_box_badge&amp;itscg=30200"
          target="_blank"
          style="display: inline-block; overflow: hidden; border-radius: 13px; width: 250px; height: 83px; margin-left: 18px;"
          ><img
            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1284940800&h=7fc6b39acc8ae5a42ad4b87ff8c7f88d"
            alt="Download on the App Store"
            style="border-radius: 13px; width: 250px; height: 83px; "
        /></a>
        <br />
        <a
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          target="_blank"
          ><img
            alt="Get it on Google Play"
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            style="width: 284px;"
        /></a>
        <div>
          <router-link class="button" :to="{ name: 'profileGetToken' }">
            {{ $t("Next") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { ref } from "@vue/reactivity";
export default {
  components: {
    Breadcrumb,
  },
  setup() {
    const breadcrumb = ref([
      { title: "Home", path: "/" },
      { title: "Profile", path: { name: "profileView" } },
      { title: "MFA", path: "#", isActive: true },
    ]);

    return {
      breadcrumb,
    };
  },
};
</script>
